import { API_URL } from '../../config';
import { toApiError } from '../../lib/api-error';

export type PagePropertyItem = { id: string; name: string; baseUrl: string };

export async function fetchPageProperties(): Promise<PagePropertyItem[]> {
  const response = await fetch(`${API_URL}/org/properties`, { credentials: 'include' });
  if (!response.ok) {
    throw await toApiError(response, 'Failed to fetch properties');
  }

  const data: { items: PagePropertyItem[] } = await response.json();
  return data.items;
}
